// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.kyc.landing.options.';

const KYC_LANDING_ACCOUNT_CHECK_OPTION = {
    description: `${DOMAIN}accountCheckDescription`,
    title: `${DOMAIN}accountCheckTitle`,
  },
  KYC_LANDING_BIZUM_OPTION = {
    description: `${DOMAIN}bizumDescription`,
    title: `${DOMAIN}bizumTitle`,
  },
  KYC_LANDING_VIDEOCALL_OPTION = {
    description: `${DOMAIN}videocallDescription`,
    title: `${DOMAIN}videocallTitle`,
  };

export { KYC_LANDING_ACCOUNT_CHECK_OPTION, KYC_LANDING_BIZUM_OPTION, KYC_LANDING_VIDEOCALL_OPTION };
